import React from 'react';
import { InputLabel, Select, MenuItem } from '@material-ui/core';
import { useQuery } from '@apollo/client';
import { GET_BRANDS } from '../../../../queries/products/brand';
import useStyles from './styles';

const GetProducts = () => useQuery(GET_BRANDS);
export const SelectBrandsPage = ({ brandId, setBrandId, labelAll, className }) => {
  const queryProducts = GetProducts();
  const classes = useStyles();
  const handleChange = (event, setValue) => {
    if (event.target.value === 'null') setValue(null);
    else setValue(event.target.value);
  };
  if (queryProducts.loading) return 'Loading...';
  if (queryProducts.error) return `Error! ${queryProducts.error.message}`;
  return (
    <>
      <InputLabel className={className || classes.inputLabel}>Brand</InputLabel>
      <Select
        fullWidth
        id="brandId"
        labelId="select-settings-brandId"
        onChange={(e) => handleChange(e, setBrandId)}
        className={classes.marginDefault}
        value={brandId != null ? brandId : 'null'}
      >
        {labelAll
          && (
            <MenuItem key="" value="null" selected>
              All
            </MenuItem>
          )}
        {queryProducts.data && queryProducts.data.listBrands ? queryProducts.data.listBrands.map((user) => <MenuItem key={user.id} value={user.id}>{user.name}</MenuItem>) : null}
      </Select>
    </>
  );
};
